import { Component, Inject, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarEvent, CalendarMonthViewDay } from 'angular-calendar';
import { isSameMonth, isSameDay } from 'date-fns';
import { DatePipe } from '@angular/common';
import { Subject, Subscription } from 'rxjs';
import { Cor } from 'src/app/models/vos/cor.model';
import { EscalaService } from 'src/app/services/operacao/escala.service';
import { PrestadorServicoService } from 'src/app/services/rh/prestador-servico.service';
// import { AuthService } from 'src/app/services/vos/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-prestador-historico-paciente',
  templateUrl: './prestador-historico-paciente.component.html',
  styleUrls: ['./prestador-historico-paciente.component.css']
})
export class PrestadorHistoricoPacienteComponent implements OnInit, OnDestroy {
  pacientes: any[] = []
  public loadingPacientes: boolean;
  private subscription: Subscription
  mes: Array<any> = []
  public loading!: boolean;
  loadingAtribuicao: boolean = true;
  profissionais: any = []
  supervisor: string = "";
  prestador: any = [];
  atribuicao: any = [];
  servico: any = [];
  // stateForm: FormGroup = this._formBuilder.group({
  //   stateGroup: '',
  // });
  // arrayPrestador: Array<IOption> = [];

  // prestadores: StateGroup[] = [];
  //CALENDARIO
  view!: string;
  viewDate: Date = new Date();
  selectedMonthViewDay!: CalendarMonthViewDay;
  selectedDayViewDate!: Date;
  events: CalendarEvent[] = [];
  selectedDays: any = [];
  @Input() locale: string = 'en';
  @Output() viewChange: EventEmitter<string> = new EventEmitter();
  @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();
  activeDayIsOpen: boolean = false;
  refresh: Subject<any> = new Subject();
  usuario: any = [];
  logo: any = []
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PrestadorHistoricoPacienteComponent>,
    private prestadorServicoService: PrestadorServicoService,
    private escalaService: EscalaService,
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    // this.buscahistoricopacientesprestador();
    this.buscaEscalaDosProfissionaisPorIdPaciente()
  }
  // buscahistoricopacientesprestador() {
  //   this.loadingPacientes = true
  //   this.subscription = this.prestadorServicoService.historicopacientesprestador(this.data.id).subscribe(res => {
  //     this.loadingPacientes = false
  //     this.pacientes = res;
  //   }, error => {
  //     Swal.fire("Ops, deu erro!", "Tente novamente mais tarde.", "error");
  //     this.loadingPacientes = false;
  //   })
  // }

  buscaEscalaDosProfissionaisPorIdPaciente() {
    this.add_day('')
    this.loading = true;
    let parametros =
    {
      dataInicio: `${new DatePipe('pt').transform(new Date(this.viewDate.getFullYear(), this.viewDate.getMonth(), 1), "yyyy-MM-dd")}`,
      dataFim: `${new DatePipe('pt').transform(new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() + 1, 0), "yyyy-MM-dd")}`,
      prestador_id: this.data.id,
    }
    this.subscription = this.escalaService.escalashistoricoEscalasPorPrestadorId(parametros).subscribe(res => {
      console.log(res);
      this.add_day(res)
      this.agruparPorEscalasPorPrestadorDoMesAtual(res.filter(x => x.dataentrada >= parametros.dataInicio && x.dataentrada <= parametros.dataFim))
      this.loading = false;
    })

  }
  add_day(array: any) {
    this.view = 'month'
    this.events = []
    let cor: Cor[] = []
    let novaData: any = new DatePipe("en-US")
    for (let i = 0; i < array.length; i++) {
      if (array[i].periodo == 'NOTURNO') cor.push({ primary: '#ad2121', secondary: '#FAE3E3' })
      if (array[i].periodo == 'DIURNO') cor.push({ primary: '#1e90ff', secondary: '#D1E8FF' })
      if (array[i].periodo == 'FOLGUISTA') cor.push({ primary: '#e3bc08', secondary: '#FDF1BA' })
      let dia = new Date(novaData.transform(array[i].dataentrada, "yyyy/MM/dd"))
      this.events.push({
        title: `${array[i].ordemservico.orcamento.homecare.paciente.pessoa.nome}`,
        start: dia,
        id: array[i].id,
        color: cor[i],
        allDay: true,
      })
    }
  }
  dayClicked({
    date,
    events
  }: {
    date: Date;
    events: Array<CalendarEvent<{ escala: any }>>;
  }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }
    }
  }
  agruparPorEscalasPorPrestadorDoMesAtual(escalas) {
    this.profissionais = []
    for (let i = 0; i < escalas.length; i++) {
      let profissionalIgual = false;
      for (let j = 0; j < i; j++) {
        if (this.profissionais[j] && escalas[i].ordemservico_id == this.profissionais[j].ordemservico_id) {
          this.profissionais[j].dias.push(escalas[i])
          profissionalIgual = true;
          break;
        }
      }
      if (!profissionalIgual) {
        this.profissionais.push({
          ordemservico_id: escalas[i].ordemservico_id,
          nome: escalas[i].ordemservico.orcamento.homecare.paciente.pessoa.nome,
          dias: [escalas[i]]
        })
      }
    }
    this.diasDoMes()

  }
  diasDoMes() {
    this.mes = []
    let ultimoDiaMes = `${new DatePipe('pt').transform(new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() + 1, 0), "dd")}`
    for (let i = 1; i <= Number(ultimoDiaMes); i++) {
      if (i < 10) {
        this.mes.push(`0${i}`)
      } else {
        this.mes.push(`${i}`);
      }
    }
  }
  verificarDiaEscalaPrestador(dias, dia) {
    const mesAno = new DatePipe("pt").transform(new Date(this.viewDate), "yyyy-MM")
    let p = dias.filter(x => x.dataentrada == `${mesAno}-${dia}`)
    let arrays = []
    if (p.length) {
      for (let i = 0; i < p.length; i++) {
        arrays.push(p[i].periodo == 'DIURNO' ? 'D' : p[i].periodo == 'NOTURNO' ? 'N' : 'F')
      }
      return arrays
    }
    else {
      return ""
    }
  }
  eventClicked(event: CalendarEvent<{ escala: any }>): void {
  }


  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
